// extracted by mini-css-extract-plugin
module.exports = {"AppLight":"App_AppLight__l1pvN","AppDark":"App_AppDark__3ETyV"};